import React from "react";
import { Autocomplete, TextField } from "@mui/material";

function MDSelectAutocomplete({
  data = [],
  value,
  onChange,
  errorText = "",
  required = false,
  disabled = false,
  placeholder = "",
}) {
  const selectedOption = data.find((item) => item.value === value) || null;
  const sortedData = [...data]?.sort((a, b) =>
    (a.title?.toLowerCase() || "").localeCompare(b.title?.toLowerCase() || "")
  );

  return (
    <>
      <Autocomplete
        options={sortedData}
        getOptionLabel={(option) => option.title || ""}
        isOptionEqualToValue={(option, val) => option.value === val.value}
        value={selectedOption}
        onChange={(e, newValue) => {
          onChange({ target: { value: newValue?.value || "" } });
        }}
        key={JSON.stringify(data)}
        disableClearable
        sx={
          !disabled && {
            backgroundColor: "#fff",
            mt: placeholder !== "Phone Number" && 2,
          }
        }
        getOptionKey={(option) => option.value}
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            {...params}
            label={placeholder}
            required={required}
            error={required && !selectedOption}
            helperText={errorText}
            variant="outlined"
          />
        )}
      />
    </>
  );
}

export default MDSelectAutocomplete;
